import React, { useEffect, useState } from 'react';
import { getGenesisStats } from '../../services/api';
import './GenesisDrop.css';

interface GenesisStats {
  total_seats: number;
  claimed_seats: number;
  is_sold_out: boolean;
}

const GenesisDrop: React.FC = () => {
  const [stats, setStats] = useState<GenesisStats | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const data = await getGenesisStats();
        setStats(data);
      } catch (err) {
        console.error('Failed to fetch genesis stats:', err);
        setError('Failed to load availability. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const remainingSeats = stats ? stats.total_seats - stats.claimed_seats : 0;
  const isSoldOut = stats?.is_sold_out || remainingSeats <= 0;

  return (
    <div className="genesis-drop-container">
      <div className="glass-card genesis-card">
        <h1 className="genesis-title">Genesis Node 01</h1>
        <p className="genesis-subtitle">AiMe Node 01 is spinning up.</p>
        
        <div className="genesis-content">
          <p>Custom bare-metal servers for maximum Gemini speeds.</p>
          <p className="genesis-highlight">Capped at 100 Founder seats.</p>
          <p className="genesis-price">$799 Lifetime Access to the Pro Tier.</p>
        </div>

        <div className="genesis-status">
          {loading ? (
            <p className="genesis-loading">Checking availability...</p>
          ) : error ? (
            <p className="genesis-error">{error}</p>
          ) : (
            <div className="genesis-counter">
              <span className="genesis-remaining-text">Only {remainingSeats} / {stats?.total_seats || 100} seats remaining</span>
              <div className="genesis-progress-bar">
                <div 
                  className="genesis-progress-fill" 
                  style={{ width: `${stats ? (stats.claimed_seats / stats.total_seats) * 100 : 0}%` }}
                ></div>
              </div>
            </div>
          )}
        </div>

        <div className="genesis-action">
          {isSoldOut ? (
            <button className="hp-btn-primary disabled" disabled>
              Sold Out
            </button>
          ) : (
            <a 
              href="https://buy.stripe.com/4gM5kD4uG2TQ5swbn77Vm00" 
              className="hp-btn-primary genesis-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Secure Lifetime Access
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default GenesisDrop;
